import { useEffect, useState } from 'react'

export const useInitUtmPayment = () => {
  const [isFromPayment, setIsFromPayment] = useState(false)

  useEffect(() => {
    if (window.location.search.includes('utm_source=payment-cyber')) {
      setIsFromPayment(true)
      sessionStorage.setItem('isFromPayment', 'true')
    } else {
      const isFromPaymentFromStorage = sessionStorage.getItem('isFromPayment')

      if (isFromPaymentFromStorage) {
        setIsFromPayment(isFromPaymentFromStorage === 'true')
      }
    }
  }, [])

  return { isFromPayment, setIsFromPayment }
}
